import styles from "./app-switch.module.scss";


export default function AppMotif({ motif }: { motif?: string }) {
  switch (motif) {
    case "signal":
      return <SignalMotif />;
    case "graph":
      return <GraphMotif />;
    case "grid":
      return <GridMotif />;
    case "shield":
      return <ShieldMotif />;
    default:
      return <GlowMotif />;
  }
}

const MOTIF_PROPS = {
  className: styles.motif,
  viewBox: "0 0 1200 620",
  preserveAspectRatio: "xMidYMid slice",
  "aria-hidden": true as const,
};

function SignalMotif() {
  const waves = [
    "M-100 310 Q 50 230 200 310 T 500 310 T 800 310 T 1100 310 T 1400 310",
    "M-100 372 Q 60 300 220 372 T 540 372 T 860 372 T 1180 372 T 1500 372",
    "M-100 248 Q 40 320 180 248 T 460 248 T 740 248 T 1020 248 T 1300 248",
  ];

  return (
    <svg {...MOTIF_PROPS}>
      <g className={styles.signal_rings}>
        {[120, 230, 350, 480].map((r, i) => (
          <circle
            key={r}
            cx="600"
            cy="310"
            r={r}
            style={{ animationDelay: `${i * 0.8}s` }}
          />
        ))}
      </g>
      <g className={styles.signal_waves}>
        {waves.map((d, i) => (
          <path key={d} d={d} style={{ animationDelay: `${i * 0.45}s` }} />
        ))}
      </g>
      <g className={styles.signal_packets}>
        {[0, 1, 2, 3, 4].map((i) => (
          <circle
            key={i}
            cx="0"
            cy={i % 2 ? 372 : 248}
            r="4"
            style={{ animationDelay: `${i * 0.6}s` }}
          />
        ))}
      </g>
    </svg>
  );
}

function GraphMotif() {
  const nodes = [
    [210, 170],
    [430, 108],
    [365, 330],
    [640, 226],
    [880, 140],
    [820, 400],
    [1030, 300],
    [175, 445],
    [575, 500],
  ];
  const edges = [
    [0, 1],
    [0, 2],
    [1, 3],
    [2, 3],
    [3, 4],
    [3, 5],
    [4, 6],
    [5, 6],
    [2, 7],
    [5, 8],
  ];

  return (
    <svg {...MOTIF_PROPS}>
      <g className={styles.graph_edges}>
        {edges.map(([a, b], i) => (
          <line
            key={`${a}-${b}`}
            x1={nodes[a][0]}
            y1={nodes[a][1]}
            x2={nodes[b][0]}
            y2={nodes[b][1]}
            style={{ animationDelay: `${i * 0.18}s` }}
          />
        ))}
      </g>
      <g className={styles.graph_nodes}>
        {nodes.map(([x, y], i) => (
          <g key={`${x}-${y}`} style={{ animationDelay: `${i * 0.14}s` }}>
            <rect x={x - 22} y={y - 16} width="44" height="32" rx="10" />
            <circle cx={x} cy={y} r="4" />
          </g>
        ))}
      </g>
    </svg>
  );
}


function GridMotif() {
  const tiles: { x: number; y: number; w: number; h: number }[] = [];
  const cols = 8;
  const rows = 4;

  for (let row = 0; row < rows; row += 1) {
    for (let col = 0; col < cols; col += 1) {
      tiles.push({
        x: 70 + col * 135,
        y: 80 + row * 130,
        w: col % 3 === 0 ? 150 : 108,
        h: row % 2 === 0 ? 92 : 74,
      });
    }
  }

  return (
    <svg {...MOTIF_PROPS}>
      <g className={styles.grid_tiles}>
        {tiles.map((tile, i) => (
          <rect
            key={`${tile.x}-${tile.y}`}
            x={tile.x}
            y={tile.y}
            width={tile.w}
            height={tile.h}
            rx="14"
            style={{ animationDelay: `${(i % cols) * 0.09 + Math.floor(i / cols) * 0.2}s` }}
          />
        ))}
      </g>
    </svg>
  );
}

function ShieldMotif() {
  const hex = (r: number) =>
    Array.from({ length: 6 }, (_, i) => {
      const angle = (Math.PI / 3) * i - Math.PI / 2;
      return `${600 + r * Math.cos(angle)},${310 + r * Math.sin(angle)}`;
    }).join(" ");

  return (
    <svg {...MOTIF_PROPS}>
      <g className={styles.shield_rings}>
        {[150, 240, 330, 430].map((r, i) => (
          <polygon
            key={r}
            points={hex(r)}
            style={{ animationDelay: `${i * 0.5}s` }}
          />
        ))}
      </g>
      <g className={styles.shield_scan}>
        <rect x="0" y="0" width="240" height="620" />
      </g>
    </svg>
  );
}

function GlowMotif() {
  return (
    <svg {...MOTIF_PROPS}>
      <g className={styles.signal_rings}>
        {[160, 280, 400].map((r, i) => (
          <circle
            key={r}
            cx="600"
            cy="310"
            r={r}
            style={{ animationDelay: `${i * 0.9}s` }}
          />
        ))}
      </g>
    </svg>
  );
}
